'use strict';

var $loader;

/**
 * @function show
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};

/**
 * @function showLoader
 * @description Shows an AJAX-custom-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var showLoader = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');
    
    if ($loader.length !== 0) {
    	$('.loader').remove();
    }
    
    $loader = $('<div/>').addClass('loader').append($('<div/>').addClass('loader-indicator-circle'), $('<div/>').addClass('loader-bg-grey'));
    
    return $loader.appendTo(target).show();
};

/**
 * @function hide
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

/**
 * @function isLoading
 * @description Describes if the AJAX-loader is visible in the grid display
 */
var isLoading = function () {

    // Exit early if the loader isn't defined
    if (($loader) === undefined) { return false; };

    // Otherwise, return the visible status
    return $loader.is(':visible');

};

exports.show = show;
exports.hide = hide;
exports.isLoading = isLoading;
exports.showLoader= showLoader;
